$(document).ready(function () {

  var rtlFlag = ($('body').hasClass('lang-rtl')) ? true : false;

  $('.reassurance-list').owlCarousel({
    nav: false,
    navText: [
      '<i class=\'fa fa-arrow-left\'></i>',
      '<i class=\'fa fa-arrow-right\'></i>'
    ],
    dots: true,
    loop: false,
    margin: 15,
    autoplay: true,
    rtl: rtlFlag,
    rewind: true,
    responsive: {
      0: {
        items: 1
      },
      320: {
        items: 1
      }
    }
  });


  /* =========================================================
     BACK TO TOP
     ========================================================= */

  $(window).scroll(function () {
    if ($(this).scrollTop() > 500) {
      $('#slidetop').fadeIn(500);
    } else {
      $('#slidetop').fadeOut(500);
    }
  });

  $('#slidetop').click(function (e) {
    e.preventDefault();

    $('html, body').animate({
      scrollTop: 0
    }, 800);
  });


  /* =========================================================
     DISABLED ZOOM FOR VIDEO
     ========================================================= */

  $(".product__media-item").click(function () {

    if ($(this).attr("data-media-type") == 'video') {
      $('.zoomContainer').hide();
    } else {
      $('.zoomContainer').show();
    }

  });


  /* =========================================================
     DEFAULT COLLAPSE
     ========================================================= */

  $(document).on("click", "[data-toggle='collapse']", function () {

    var parent = $(this).data("parent");
    var target = $(this).data("href");

    if ($(parent).length && $(parent).hasClass('panel-group')) {

      $(parent + " .panel").each(function () {

        var p = $(this).find("[data-toggle='collapse']");
        var t = p.data("href");

        if (t != target && p.attr("aria-expanded") == "true") {

          $(t).slideUp().removeClass("in");

          p.addClass("ishi-collapsed")
            .attr("aria-expanded", "false");
        }

      });

    }

    if ($(this).attr("aria-expanded") == "false") {

      $(target).slideDown().addClass("in");

      $(this)
        .removeClass("ishi-collapsed")
        .attr("aria-expanded", "true");

    } else {

      $(target).slideUp().removeClass("in");

      $(this)
        .addClass("ishi-collapsed")
        .attr("aria-expanded", "false");

    }

  });


  /* =========================================================
     DEFAULT POPOVER
     ========================================================= */

  $(document).on("click", "[data-toggle='popover']", function () {

    var target = $(this).data("href");

    if ($(this).attr("aria-expanded") == "false") {

      $(target).addClass("active");

      $(this).attr("aria-expanded", "true");

    } else {

      $(target).removeClass("active");

      $(this).attr("aria-expanded", "false");

    }

  });


  $(document).on("click", function (event) {

    if (
      !$(event.target).closest('#search-container-full').length &&
      !$(event.target).closest('[data-href="#search-container-full"]').length
    ) {

      if ($('[data-href="#search-container-full"]').attr("aria-expanded") == "true") {

        $("#search-container-full").removeClass("active");

        $('[data-href="#search-container-full"]')
          .attr("aria-expanded", "false");
      }

    }


    if (
      !$(event.target).closest('#user-notification').length &&
      !$(event.target).closest('[data-href="#user-notification"]').length
    ) {

      if ($('[data-href="#user-notification"]').attr("aria-expanded") == "true") {

        $("#user-notification").removeClass("active");

        $('[data-href="#user-notification"]')
          .attr("aria-expanded", "false");

        event.preventDefault();
      }

    }


    if (
      !$(event.target).closest('#HeaderCountryList').length &&
      !$(event.target).closest('[data-href="#HeaderCountryList"]').length
    ) {

      if ($('[data-href="#HeaderCountryList"]').attr("aria-expanded") == "true") {

        $("#HeaderCountryList").removeClass("active");

        $('[data-href="#HeaderCountryList"]')
          .attr("aria-expanded", "false");
      }

    }


    if (
      !$(event.target).closest('#HeaderLanguageList').length &&
      !$(event.target).closest('[data-href="#HeaderLanguageList"]').length
    ) {

      if ($('[data-href="#HeaderLanguageList"]').attr("aria-expanded") == "true") {

        $("#HeaderLanguageList").removeClass("active");

        $('[data-href="#HeaderLanguageList"]')
          .attr("aria-expanded", "false");
      }

    }

  });


  /* =========================================================
     DEFAULT TABS
     ========================================================= */

  $(document).on("click", ".ishi-nav-link", function () {

    $(this)
      .parents(".ishi-nav-tabs")
      .find(".ishi-tab-item")
      .removeClass("active");

    $(this)
      .parents(".ishi-tab-item")
      .addClass("active");

    $(this)
      .parents(".ishi-product-tab")
      .find(".ishi-tab-pane")
      .removeClass("active");

    var target = $(this).data("href");

    $(target).addClass("active");

  });


  /* =========================================================
     DEFAULT PANEL
     ========================================================= */

  $(document).on("click", '[data-action="ishi-panel"]', function () {

    var target = $(this).attr("aria-controls");

    $(this)
      .parents(".ishi-panel-container")
      .find(".ishi-panel-data")
      .removeClass("active");

    $(target).addClass("active");

  });


  /* =========================================================
     DEFAULT WISHLIST
     ========================================================= */

  if ($(".add-in-wishlist-js").length != 0) {

    $(document).on("click", ".add-in-wishlist-js", function (event) {

      if ($(this).hasClass("added-wishlist")) {
        return true;
      }

      event.preventDefault();

      try {

        var id = $(this).data('href');
        var str = "";

        if (getTheCookie("wishlist") == null) {

          str = id;

        } else {

          if (getTheCookie("wishlist").indexOf(id) == -1) {

            str = getTheCookie("wishlist") + '__' + id;

          } else {

            str = getTheCookie("wishlist");
          }

        }

        setTheCookie("wishlist", str, 14);

        $('.loadding-wishbutton-' + id).show();
        $('.default-wishbutton-' + id).remove();

        setTimeout(function () {

          $('.loadding-wishbutton-' + id).remove();
          $('.added-wishbutton-' + id).show();

        }, 2000);

      } catch (err) {

        console.log("error reading wishlist cookies!");

      }

    });

  }

  setupWishlistButtons();


  /* =========================================================
     CART PAGE EDIT BUTTON
     ========================================================= */

  $(document).on("click", ".js-edit-toggle", function () {

    $(this)
      .parents("tr")
      .toggleClass("cart__update--show");

    $(this)
      .toggleClass("cart__edit--active");

  });


  /* =========================================================
     STOCK URGENCY
     ========================================================= */

  var stock = parseInt($("#variant-stock").html());
  var maxqty = parseInt($(".selected-variant").data("quantity"));

  if (stock == '' || stock <= 0) {

    $(".ishi-progress-content").addClass('hidden');

  }

  switch (stock) {

    case 9:
      $("#ishi-progress-bar span").css("width", "65%");
      break;

    case 8:
      $("#ishi-progress-bar span").css("width", "60%");
      break;

    case 7:
      $("#ishi-progress-bar span").css("width", "55%");
      break;

    case 6:
      $("#ishi-progress-bar span").css("width", "50%");
      break;

    case 5:
      $("#ishi-progress-bar span").css("width", "40%");
      break;

    case 4:
      $("#ishi-progress-bar span").css("width", "30%");
      break;

    case 3:
      $("#ishi-progress-bar span").css("width", "20%");
      break;

    case 2:
      $("#ishi-progress-bar span").css("width", "10%");
      break;

    case 1:
      $("#ishi-progress-bar span").css("width", "5%");
      break;

    default:
      $("#ishi-progress-bar span").css("width", "90%");
  }


  /* =========================================================
     PRODUCT MEDIA CHANGE ON CLICK
     ========================================================= */

  $(document).on(
    "click",
    ".product__media-list .product__media-item",
    function () {

      if ($(this).data("media-type") != "model") {

        $('#main-media-container').html($(this).clone());

      }

    }
  );


  if (
    $("#main-media-container").length &&
    window.matchMedia("(min-width: 991px)").matches
  ) {

    $("#main-media-container img").elevateZoom({
      zoomType: "inner",
      cursor: "crosshair"
    });

  }


  $(document).on(
    "DOMSubtreeModified",
    "#main-media-container",
    function () {

      if (
        window.matchMedia("(min-width: 991px)").matches &&
        $(this)
          .find(".product__media-item")
          .data("media-type") != "video"
      ) {

        $("#main-media-container img").elevateZoom({
          zoomType: "inner",
          cursor: "crosshair"
        });

      }

    }
  );


  /* =========================================================
     PRODUCT THUMBNAILS SLIDER
     ========================================================= */

  $('.product__media-list').owlCarousel({

    nav: true,

    navText: [

      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',

      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'

    ],

    dots: false,
    loop: false,
    margin: 15,
    rtl: rtlFlag,
    rewind: true,

    responsive: {

      0: {
        items: 3
      },

      544: {
        items: 4
      },

      768: {
        items: 3
      },

      992: {
        items: $('#shopify-section-Ishi_sidebar').length ? 3 : 4
      },

      1200: {
        items: 4
      }

    }

  });


  /* =========================================================
     COLLECTION GRID / LIST
     ========================================================= */

  $(document).on("click", ".collectiongrid-layout", function () {

    var id = $(this).data("id");

    setTheCookie(
      "collectiongrid-layout",
      id,
      14
    );

    setGridLayout();

  });

  setGridLayout();


  /* =========================================================
     NORMAL CART BUTTONS
     ========================================================= */

  $(document).on("click", ".add-to-cart-js", function () {

    var variantID = this.getAttribute("data-variantid");

    $(this).addClass("loading");

    addToCartJS(
      1,
      variantID,
      this
    );

  });


  $(document).on("click", ".cart-remove-js", function () {

    var variantID = this.getAttribute("data-variantid");

    removeFromCartJS(variantID);

  });


  $(document).on("click", ".minicart-quantity__button", function () {

    var variantID = this.getAttribute("data-variantid");

    var quantity = $(this)
      .parents(".quantity")
      .find(".quantity__input")
      .val();

    updateCartItemJS(
      quantity,
      variantID
    );

  });


  /* =========================================================
     RIC QUICK VIEW OPENER
     ========================================================= */

  $(document).on("click", ".quick-view", function () {

    var btn = $(this);

    /*
     * SEARCH QUICK VIEW — USE THE CLICKED CARD AS THE SOURCE OF TRUTH
     *
     * Search results can be replaced/reordered by Shopify and by the
     * theme's filtering/search UI. Never trust a cached jQuery value or
     * another product card on the page. Resolve the product from the
     * actual clicked card's product URL first, then fall back to its
     * live data-handle.
     */
    var handle = "";
    var productUrl = btn.attr("data-ric-product-url") || "";
    var card = btn.closest(".ric-search-product-item, .card-wrapper, li").first();

    if (document.body.classList.contains("template-search")) {
      var cardProductLink = card.find("a.ric-product-link").first();
      var cardHref = cardProductLink.attr("href") || "";

      if (cardHref) {
        productUrl = cardHref;
      }
    }

    if (productUrl) {
      try {
        var productUrlObject = new URL(productUrl, window.location.origin);
        var productPath = productUrlObject.pathname.replace(/\/+$/, "");
        var productParts = productPath.split("/");
        var productIndex = productParts.indexOf("products");

        if (productIndex !== -1 && productParts[productIndex + 1]) {
          handle = decodeURIComponent(productParts[productIndex + 1]).trim();
        }
      } catch (error) {
        console.warn("RIC Quick View: Could not resolve product URL.", error);
      }
    }

    if (!handle) {
      handle = String(btn.attr("data-handle") || "").trim();
    }

    /*
     * Marketplace URLs are taken from the
     * Quick View trigger itself.
     */
    var shopeeUrl =
      btn.attr("data-shopee-url") || "";

    var lazadaUrl =
      btn.attr("data-lazada-url") || "";

    var tiktokUrl =
      btn.attr("data-tiktok-url") || "";


    updateQuickViewMarketplaceButtons(
      shopeeUrl,
      lazadaUrl,
      tiktokUrl
    );


    /*
     * Load Quick View exactly once.
     */
    loadQuickView(
      handle,
      btn
    );

  });


  /* =========================================================
     SIDEBAR FILTERS
     ========================================================= */

  if (
    $("#FacetFiltersFormSidebar [type='checkbox']:checked").length
  ) {

    $("#FacetFiltersFormSidebar .clear-all")
      .css("display", "inline-block");

  }


  /* =========================================================
     INITIALIZE OWL SLIDERS
     ========================================================= */

  $(".owl-carousel.slider-with-options").each(function () {

    $(this).owlCarousel({

      lazyLoad: true,

      navText: [

        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',

        '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'

      ],

      loop: ($(this).data("loop")) ? true : false,
      rewind: ($(this).data("rewind")) ? true : false,
      nav: ($(this).data("nav")) ? true : false,
      rtl: rtlFlag,
      autoplay: ($(this).data("autoplay")) ? true : false,
      dots: ($(this).data("dots")) ? true : false,

      autoplayTimeout:
        ($(this).data("autoplaytimeout"))
          ? $(this).data("autoplaytimeout")
          : 4000,

      smartSpeed:
        ($(this).data("smartspeed"))
          ? $(this).data("smartspeed")
          : 500,

      margin:
        ($(this).data("margin"))
          ? $(this).data("margin")
          : 0,

      responsive: {

        0: {
          items: $(this).data("small")
        },

        544: {
          items: $(this).data("mobile")
        },

        768: {
          items: $(this).data("tablet")
        },

        992: {
          items: $(this).data("laptop")
        },

        1200: {
          items: $(this).data("desktop")
        }

      }

    });

  });


  /* =========================================================
     COUNTDOWN TIMER
     ========================================================= */

  $('[data-deal="1"]').each(function () {

    setCountDownTimer(
      $(this).data("counter"),
      this.querySelector(".countdowncontainer")
    );

  });


  /* =========================================================
     WRITE COMMENT
     ========================================================= */

  $(".write_comment").click(function (e) {

    $('.ishi-product-tab .ishi-nav-tabs a.review-tab')
      .trigger('click');

    $('html, body').animate({
      scrollTop:
        $(".ishi-product-tab").offset().top - 70
    }, 2000);

  });


  /* =========================================================
     FIXED HEADER
     ========================================================= */

  adjustFixedHeader();

  $(window).scroll(function () {
    adjustFixedHeader();
  });


  /* =========================================================
     RESPONSIVE HEADER
     ========================================================= */

  var shopify_responsive_current_width =
    window.innerWidth;

  var shopify_responsive_min_width = 992;

  var shopify_responsive_mobile =
    shopify_responsive_current_width <
    shopify_responsive_min_width;


  if (shopify_responsive_mobile) {

    convertToMobile();

  }


  $(window).on('resize', function () {

    var _mw =
      shopify_responsive_min_width;

    var _w =
      window.innerWidth;

    var desktopContent =
      $("*[id^='_desktop_']")
        .first()
        .html()
        .trim()
        .length;

    var mobileContent =
      $("*[id^='_mobile_']")
        .first()
        .html()
        .trim()
        .length;


    if (_w < _mw && desktopContent) {

      convertToMobile();

    }


    if (_w >= _mw && mobileContent) {

      convertToDesktop();

    }

  });


  /* =========================================================
     MOBILE MENU
     ========================================================= */

  $('#menu-icon').on('click', function () {

    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });

    $('.mobile-menu-overlay')
      .toggleClass("active");

  });


  $('#top_menu_closer svg').on('click', function () {

    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });

    $('.mobile-menu-overlay')
      .toggleClass("active");

  });


  $('.mobile-menu-overlay').on('click', function () {

    $("#mobile_top_menu_wrapper").animate({
      width: "toggle"
    });

    $('.mobile-menu-overlay')
      .toggleClass("active");

  });


  /* =========================================================
     CART DRAWER
     ========================================================= */

  $('.cart-drawer-toggler').on('click', function () {

    openCartDrawer();

  });


  $('#cart-notification-closer svg').on('click', function () {

    closeCartDrawer();

  });


  $('.cart-overlay').on('click', function () {

    closeCartDrawer();

  });

});



/* =========================================================
   CONVERT TO MOBILE
   ========================================================= */

function convertToMobile() {

  $("*[id^='_desktop_']").each(function (index, element) {

    var target =
      $('#' + element.id.replace(
        '_desktop_',
        '_mobile_'
      ));

    swapElements(
      $(this),
      target
    );

  });

}



/* =========================================================
   CONVERT TO DESKTOP
   ========================================================= */

function convertToDesktop() {

  $("*[id^='_mobile_']").each(function (index, element) {

    var target =
      $('#' + element.id.replace(
        '_mobile_',
        '_desktop_'
      ));

    swapElements(
      $(this),
      target
    );

  });


  if ($("#main-media-container").length) {

    $("#main-media-container img").elevateZoom({
      zoomType: "inner",
      cursor: "crosshair"
    });

  }

}



/* =========================================================
   SWAP ELEMENTS
   ========================================================= */

function swapElements(source, destination) {

  var temp =
    destination.children().detach();

  destination
    .empty()
    .append(source.children().detach());

  source.append(temp);

}



/* =========================================================
   FIXED HEADER
   ========================================================= */

function adjustFixedHeader() {

  var headerHeight =
    $('#header').height();

  var navHeightMobile =
    $('#header').height();


  if (window.matchMedia('(min-width: 992px)').matches) {

    $('.mobile-width')
      .removeClass('fixed-header');


    if ($(window).scrollTop() > headerHeight) {

      $('.header-top')
        .addClass('fixed-header');

    } else {

      $('.header-top')
        .removeClass('fixed-header');

    }

  }


  if (window.matchMedia('(max-width: 991px)').matches) {

    $('.header-top')
      .removeClass('fixed-header');


    if ($(window).scrollTop() > navHeightMobile) {

      $('.mobile-width')
        .addClass('fixed-header');

    } else {

      $('.mobile-width')
        .removeClass('fixed-header');

    }

  }

}



/* =========================================================
   RIC SMART PRODUCT SEARCH
   ========================================================= */

$(function () {

  var currentAjaxRequest = null;
  var searchTimer = null;


  $('form[action="/search"]').each(function () {

    var form = $(this);

    var input =
      form.find('input[name="q"]').first();


    if (!input.length) {
      return;
    }


    form.css(
      "position",
      "relative"
    );


    var resultsList =
      $('<ul class="search-results"></ul>');


    resultsList
      .hide()
      .appendTo(form);


    /*
     * =======================================================
     * SEARCH INPUT
     * =======================================================
     */

    input
      .attr("autocomplete", "off")
      .on("input", function () {

        var term =
          $.trim($(this).val());


        clearTimeout(searchTimer);


        if (term.length < 2) {

          resultsList
            .stop(true, true)
            .hide()
            .empty();

          return;

        }


        searchTimer =
          setTimeout(function () {

            if (currentAjaxRequest) {

              currentAjaxRequest.abort();

            }


            var searchURL =
              "/search?type=product" +
              "&options[prefix]=last" +
              "&options[unavailable_products]=hide" +
              "&q=" +
              encodeURIComponent(term) +
              "&view=json";


            currentAjaxRequest =
              $.getJSON(
                searchURL,
                function (data) {

                  resultsList.empty();


                  var results =
                    Array.isArray(data.results)
                      ? data.results
                      : [];


                  /*
                   * Product-only safety filter.
                   */

                  results =
                    results.filter(function (item) {

                      return (
                        item &&
                        item.id &&
                        item.title &&
                        item.url
                      );

                    });


                  if (!results.length) {

                    resultsList
                      .hide();

                    return;

                  }


                  /*
                   * Limit dropdown to the most relevant
                   * first 8 products.
                   */

                  results
                    .slice(0, 8)
                    .forEach(function (item) {

                      var li =
                        document.createElement("li");


                      var link =
                        document.createElement("a");


                      link.href =
                        item.url;


                      link.setAttribute(
                        "data-ric-product-click",
                        "true"
                      );


                      link.setAttribute(
                        "data-ric-product-name",
                        item.title || ""
                      );


                      link.setAttribute(
                        "data-ric-product-id",
                        item.id || ""
                      );


                      link.setAttribute(
                        "data-ric-variant-id",
                        item.variant_id || ""
                      );


                      link.setAttribute(
                        "data-ric-variant-title",
                        item.variant_title || ""
                      );


                      link.setAttribute(
                        "data-ric-product-url",
                        item.url || ""
                      );


                      link.setAttribute(
                        "data-ric-click-location",
                        "search-dropdown"
                      );


                      /*
                       * Image
                       */

                      var imageWrap =
                        document.createElement("span");

                      imageWrap.className =
                        "thumbnail";


                      var image =
                        document.createElement("img");


                      image.src =
                        item.thumbnail || "";


                      image.alt =
                        item.title || "";


                      image.loading =
                        "lazy";


                      imageWrap.appendChild(
                        image
                      );


                      /*
                       * Product information
                       */

                      var info =
                        document.createElement("span");

                      info.className =
                        "ric-search-dropdown-info";


                      var title =
                        document.createElement("span");

                      title.className =
                        "title";

                      title.textContent =
                        item.title;


                      var type =
                        document.createElement("span");

                      type.className =
                        "type";

                      type.textContent =
                        item.type ||
                        "Product";


                      info.appendChild(
                        title
                      );

                      info.appendChild(
                        type
                      );


                      /*
                       * Price
                       */

                      var price =
                        document.createElement("span");

                      price.className =
                        "price";

                      price.textContent =
                        item.price || "";


                      link.appendChild(
                        imageWrap
                      );

                      link.appendChild(
                        info
                      );

                      link.appendChild(
                        price
                      );


                      li.appendChild(
                        link
                      );


                      resultsList.append(
                        li
                      );

                    });


                  /*
                   * View all results.
                   */

                  if (data.results_count > 8) {

                    var allLi =
                      document.createElement("li");


                    var allLink =
                      document.createElement("a");


                    allLink
                      .className =
                      "ric-search-dropdown-all";


                    allLink.href =
                      "/search?type=product&q=" +
                      encodeURIComponent(term);


                    allLink.textContent =
                      "VIEW ALL " +
                      data.results_count +
                      " PRODUCTS →";


                    allLi.appendChild(
                      allLink
                    );


                    resultsList.append(
                      allLi
                    );

                  }


                  resultsList
                    .stop(true, true)
                    .fadeIn(150);

                }
              )

              .fail(function (
                xhr,
                status
              ) {

                if (
                  status !== "abort"
                ) {

                  resultsList
                    .hide()
                    .empty();

                }

              });

          }, 180);

      });

  });


  /*
   * Close dropdown when clicking outside.
   */

  $(document).on(
    "click",
    function (event) {

      if (
        !$(event.target)
          .closest("form[action='/search']")
          .length
      ) {

        $(".search-results")
          .hide();

      }

    }
  );

});



/* =========================================================
   RIC QUICK VIEW
   ========================================================= */


/* ---------------------------------------------------------
   Quick View state
   --------------------------------------------------------- */

var ricQuickViewProduct = null;
var ricQuickViewCurrentVariant = null;



/* ---------------------------------------------------------
   Marketplace buttons
   --------------------------------------------------------- */

function updateQuickViewMarketplaceButtons(
  shopeeUrl,
  lazadaUrl,
  tiktokUrl
) {

  var marketplaceContainer =
    $("#qv-marketplace-buttons");

  var shopeeButton =
    $("#qv-marketplace-shopee");

  var lazadaButton =
    $("#qv-marketplace-lazada");

  var tiktokButton =
    $("#qv-marketplace-tiktok");


  if (!marketplaceContainer.length) {
    return;
  }


  /*
   * Always reset first.
   * Quick View is reused for different products.
   */

  shopeeButton
    .attr("href", "#")
    .hide();

  lazadaButton
    .attr("href", "#")
    .hide();

  tiktokButton
    .attr("href", "#")
    .hide();


  if (
    shopeeUrl &&
    String(shopeeUrl).trim() !== ""
  ) {

    shopeeButton
      .attr(
        "href",
        String(shopeeUrl).trim()
      )
      .show();

  }


  if (
    lazadaUrl &&
    String(lazadaUrl).trim() !== ""
  ) {

    lazadaButton
      .attr(
        "href",
        String(lazadaUrl).trim()
      )
      .show();

  }


  if (
    tiktokUrl &&
    String(tiktokUrl).trim() !== ""
  ) {

    tiktokButton
      .attr(
        "href",
        String(tiktokUrl).trim()
      )
      .show();

  }


  if (
    (
      shopeeUrl &&
      String(shopeeUrl).trim() !== ""
    ) ||
    (
      lazadaUrl &&
      String(lazadaUrl).trim() !== ""
    ) ||
    (
      tiktokUrl &&
      String(tiktokUrl).trim() !== ""
    )
  ) {

    marketplaceContainer.show();

  } else {

    marketplaceContainer.hide();

  }

}



/* ---------------------------------------------------------
   Quick View opener
   --------------------------------------------------------- */

function loadQuickView(handle, btn) {

  /*
   * Cancel any previous Quick View request. This prevents a slower
   * response from a previously clicked Search result from overwriting
   * the product the customer just selected.
   */
  if (window.ricQuickViewAbortController) {
    try {
      window.ricQuickViewAbortController.abort();
    } catch (error) {}
  }

  window.ricQuickViewAbortController =
    typeof AbortController !== "undefined"
      ? new AbortController()
      : null;

  var requestToken =
    (window.ricQuickViewRequestToken || 0) + 1;

  window.ricQuickViewRequestToken = requestToken;

  ricQuickViewProduct = null;
  ricQuickViewCurrentVariant = null;


  /*
   * RESET QUICK VIEW
   */

  $("#qv-variants").html("");

  $("#qv-productname").html("");

  $("#qv-productdescription").html("");

  $("#qv-price").html("");

  $("#qv-compareatprice").html("");

  $("#qv-spr-badge").html("");

  $("#qv-thumbnails").html("");

  $("#qv-variantid").val("");

  $("#qv-add-to-cart")
    .removeClass("sold-out loading")
    .prop("disabled", true)
    .text("ADD TO CART");


  /*
   * Reset image to loading/no-image state.
   */

  $("#qv-product-cover img")
    .attr(
      "src",
      $("#qv-product-cover img").attr("data-qv-placeholder") ||
      $("#qv-product-cover img").attr("src")
    );


  $(".qv-wrapper")
    .addClass("loading");


  if (!handle) {

    console.error(
      "RIC Quick View: No product handle."
    );

    $(".qv-wrapper")
      .removeClass("loading");

    return;

  }


  /*
   * =========================================================
   * SHOPIFY PRODUCT JSON
   * =========================================================
   *
   * Shopify's product JSON endpoint returns the actual
   * product, images, variants, prices and descriptions.
   */

  var root =
    window.Shopify &&
    Shopify.routes &&
    Shopify.routes.root
      ? Shopify.routes.root
      : "/";

  var endpoint =
    root.replace(/\/$/, "") +
    "/products/" +
    encodeURIComponent(handle) +
    ".js";

  /* Search-page source of truth: the exact product URL on the clicked card. */
  if (document.body.classList.contains("template-search") && btn && btn.length) {
    var searchCardLink = btn
      .closest(".ric-search-product-item, .card-wrapper, li")
      .first()
      .find("a.ric-product-link")
      .first();

    var exactProductUrl =
      searchCardLink.attr("href") ||
      btn.attr("data-ric-product-url") ||
      "";

    if (exactProductUrl) {
      try {
        var exactUrl = new URL(exactProductUrl, window.location.origin);
        var exactPath = exactUrl.pathname.replace(/\/+$/, "");
        var exactParts = exactPath.split("/");
        var exactProductIndex = exactParts.indexOf("products");

        if (exactProductIndex !== -1 && exactParts[exactProductIndex + 1]) {
          handle = decodeURIComponent(exactParts[exactProductIndex + 1]).trim();
          endpoint = exactPath + ".js";
        }
      } catch (error) {
        console.warn("RIC Quick View: Could not build exact Search product endpoint.", error);
      }
    }
  }


  fetch(
    endpoint,
    {
      method: "GET",
      headers: {
        "Accept": "application/json"
      },
      credentials: "same-origin",
      signal: window.ricQuickViewAbortController
        ? window.ricQuickViewAbortController.signal
        : undefined
    }
  )

  .then(function (response) {

    if (!response.ok) {

      throw new Error(
        "HTTP " +
        response.status +
        " while loading " +
        endpoint
      );

    }

    return response.json();

  })

  .then(function (product) {

    if (requestToken !== window.ricQuickViewRequestToken) {
      return;
    }

    if (!product) {

      throw new Error(
        "Empty Shopify product response."
      );

    }

    /* Never render a different product than the clicked Search card. */
    if (
      document.body.classList.contains("template-search") &&
      product.handle &&
      String(product.handle) !== String(handle)
    ) {
      throw new Error(
        "Quick View product mismatch. Expected " +
        handle +
        " but received " +
        product.handle
      );
    }


    /*
     * Store product globally.
     */

    ricQuickViewProduct = product;


    /*
     * =======================================================
     * PRODUCT TITLE
     * =======================================================
     */

    $("#qv-productname")
      .text(product.title || "");


    /*
     * =======================================================
     * DESCRIPTION
     * =======================================================
     */

    $("#qv-productdescription")
      .html(product.description || "");


    if (
      product.description &&
      product.description.length >= 300
    ) {

      $(".more-description")
        .css("display", "block");

    } else {

      $(".more-description")
        .css("display", "none");

    }


    /*
     * =======================================================
     * MAIN IMAGE
     * =======================================================
     */

    if (product.featured_image) {

      $("#qv-product-cover img")
        .attr(
          "src",
          product.featured_image
        );

    } else if (
      product.images &&
      product.images.length
    ) {

      $("#qv-product-cover img")
        .attr(
          "src",
          product.images[0]
        );

    }


    /*
     * =======================================================
     * PRODUCT REVIEWS
     * =======================================================
     */

    var reviews =
      $('[data-handle="' + handle + '"]')
        .closest(".card-wrapper")
        .find(".spr-badge")
        .first()
        .clone();


    if (reviews.length) {

      $("#qv-spr-badge")
        .html(reviews.html());

    }


    /*
     * =======================================================
     * PRODUCT THUMBNAILS
     * =======================================================
     */

    prepareQvThumbnails(
      product.images || []
    );


    /*
     * =======================================================
     * VARIANTS
     * =======================================================
     */

    if (
      product.variants &&
      product.variants.length
    ) {

      buildQuickViewVariants(product);

    } else {

      console.warn(
        "RIC Quick View: Product has no variants."
      );

    }


    /*
     * =======================================================
     * MARKETPLACE BUTTONS
     * =======================================================
     */

    if (btn && btn.length) {

      updateQuickViewMarketplaceButtons(

        btn.attr("data-shopee-url") || "",

        btn.attr("data-lazada-url") || "",

        btn.attr("data-tiktok-url") || ""

      );

    }


    /*
     * Finished loading.
     */

    $(".qv-wrapper")
      .removeClass("loading");

  })

  .catch(function (error) {

    console.error(
      "RIC Quick View failed:",
      error
    );


    $("#qv-productname")
      .text("Unable to load product");


    $("#qv-productdescription")
      .html(
        "<p>Product information could not be loaded. Please open the product page directly.</p>"
      );


    $("#qv-add-to-cart")
      .prop("disabled", true)
      .removeClass("loading")
      .addClass("sold-out")
      .text("UNAVAILABLE");


    $(".qv-wrapper")
      .removeClass("loading");

  });

}


/* ---------------------------------------------------------
   Build Quick View variant controls
   --------------------------------------------------------- */

function buildQuickViewVariants(product) {

  var options =
    product.options || [];


  $("#qv-variants")
    .html("");


  /*
   * Build option controls.
   */

  $(options).each(function (optionIndex, option) {

    var position =
      optionIndex + 1;

    var name =
      option.name || ("Option " + position);


    var swatchWrapper =
      $('<div class="swatch-wrapper"></div>')
        .attr(
          "data-index",
          position
        );


    var optionValues =
      $('<div class="option-values product-form__input"></div>')
        .addClass(
          name.toLowerCase()
        );


    swatchWrapper.append(
      '<div class="option-label"><label>' +
      name +
      '</label></div>'
    );


    /*
     * Option values.
     */

    $(option.values || []).each(
      function (valueIndex, value) {

        var inputId =
          "qv-" +
          position +
          "-" +
          valueIndex;


        /*
         * Radio input.
         */

        var radio =
          $('<input>')
            .attr({
              id: inputId,
              type: "radio",
              value: value,
              name: "qv-option-" + position
            });


        if (valueIndex === 0) {
          radio.prop("checked", true);
        }


        /*
         * Visible label.
         */

        var labelClass =
          value.length < 3
            ? "square"
            : "label";


        var label =
          $('<label></label>')
            .attr({
              "for": inputId,
              "data-index": valueIndex,
              "data-option-position": position
            })
            .addClass(labelClass)
            .text(value);


        optionValues.append(radio);
        optionValues.append(label);

      }
    );


    swatchWrapper.append(
      optionValues
    );


    $("#qv-variants")
      .append(swatchWrapper);


    /*
     * Dropdown.
     *
     * This remains for compatibility with
     * the existing Quick View structure.
     */

    var selectWrapper =
      $('<div class="dropdown-wrapper"></div>');


    var selectOptionValues =
      $('<div class="option-values product-form__input"></div>');


    var selectBoxWrapper =
      $('<div class="select"></div>');


    var selectBox =
      $('<select></select>')
        .attr({
          id: "select-option" + position,
          name: "options[" + position + "]",
          class: "select__select",
          "data-qv-option-position": position
        });


    $(option.values || []).each(
      function (valueIndex, value) {

        var optionElement =
          $('<option></option>')
            .attr("value", value)
            .text(value);


        if (valueIndex === 0) {

          optionElement.prop(
            "selected",
            true
          );

        }


        selectBox.append(
          optionElement
        );

      }
    );


    selectBoxWrapper.append(
      selectBox
    );


    selectOptionValues.append(
      selectBoxWrapper
    );


    selectWrapper.append(
      '<div class="option-label"><label>' +
      name +
      '</label></div>'
    );


    selectWrapper.append(
      selectOptionValues
    );


    $("#qv-variants")
      .append(selectWrapper);

  });


  /*
   * First variant calculation.
   */

  updateQuickViewVariant();


  /*
   * Disable impossible option combinations.
   */

  updateQuickViewOptionAvailability();

}



/* ---------------------------------------------------------
   Normalize option values
   --------------------------------------------------------- */

function normalizeQvValue(value) {

  if (
    value === null ||
    typeof value === "undefined"
  ) {

    return "";

  }


  return String(value)
    .trim()
    .toLowerCase();

}



/* ---------------------------------------------------------
   Get currently selected options
   --------------------------------------------------------- */

function getQuickViewSelectedOptions() {

  var selectedOptions = [];


  if (
    !ricQuickViewProduct ||
    !ricQuickViewProduct.options
  ) {

    return selectedOptions;

  }


  $(ricQuickViewProduct.options).each(
    function (index) {

      var select =
        $("#select-option" + (index + 1));


      if (select.length) {

        selectedOptions.push(
          select.val()
        );

      } else {

        selectedOptions.push("");

      }

    }
  );


  return selectedOptions;

}



/* ---------------------------------------------------------
   Find exact Shopify variant
   --------------------------------------------------------- */

function findQuickViewVariant(options) {

  if (
    !ricQuickViewProduct ||
    !ricQuickViewProduct.variants
  ) {

    return null;

  }


  var wantedOptions =
    options.map(
      normalizeQvValue
    );


  /*
   * IMPORTANT:
   *
   * We compare the actual Shopify
   * variant.options array.
   *
   * We no longer depend on an index
   * mapping between separate arrays.
   */

  for (
    var i = 0;
    i < ricQuickViewProduct.variants.length;
    i++
  ) {

    var variant =
      ricQuickViewProduct.variants[i];


    if (
      !variant.options ||
      variant.options.length !== wantedOptions.length
    ) {

      continue;

    }


    var match = true;


    for (
      var optionIndex = 0;
      optionIndex < wantedOptions.length;
      optionIndex++
    ) {

      if (
        normalizeQvValue(
          variant.options[optionIndex]
        ) !== wantedOptions[optionIndex]
      ) {

        match = false;
        break;

      }

    }


    if (match) {

      return variant;

    }

  }


  return null;

}



/* ---------------------------------------------------------
   Update Quick View variant
   --------------------------------------------------------- */

function updateQuickViewVariant() {

  if (!ricQuickViewProduct) {
    return;
  }


  var selectedOptions =
    getQuickViewSelectedOptions();


  var variant =
    findQuickViewVariant(
      selectedOptions
    );


  ricQuickViewCurrentVariant =
    variant;


  /*
   * No matching variant.
   */

  if (!variant) {

    $("#qv-variantid")
      .val("");


    $("#qv-price")
      .html("");


    $("#qv-compareatprice")
      .html("");


    $("#qv-add-to-cart")
      .addClass("sold-out")
      .prop("disabled", true)
      .removeClass("loading")
      .text("UNAVAILABLE");


    return;

  }


  /*
   * Store the REAL Shopify variant ID.
   */

  $("#qv-variantid")
    .val(variant.id);


  /*
   * Update product image.
   */

  if (
    variant.featured_image &&
    variant.featured_image.src
  ) {

    $("#qv-product-cover img")
      .attr(
        "src",
        variant.featured_image.src
      );

  }


  /*
   * PRICE
   *
   * Shopify product JSON returns prices
   * in cents.
   */

  var price =
    Number(variant.price);


  var compareAtPrice =
    variant.compare_at_price !== null
      ? Number(variant.compare_at_price)
      : null;


  /*
   * Never allow NaN to enter the UI.
   */

  if (
    Number.isFinite(price)
  ) {

    if (
      Number.isFinite(compareAtPrice) &&
      compareAtPrice > price
    ) {

      $("#qv-compareatprice")
        .html(
          convertToMoney(
            compareAtPrice
          )
        );

    } else {

      $("#qv-compareatprice")
        .html("");

    }


    $("#qv-price")
      .html(
        convertToMoney(price)
      );

  } else {

    $("#qv-price")
      .html("");

    $("#qv-compareatprice")
      .html("");

  }


  /*
   * AVAILABILITY
   *
   * This now uses the exact Shopify
   * variant selected by the customer.
   */

  if (variant.available) {

    $("#qv-add-to-cart")
      .removeClass("sold-out")
      .prop("disabled", false)
      .removeClass("loading")
      .text("ADD TO CART");

  } else {

    $("#qv-add-to-cart")
      .addClass("sold-out")
      .prop("disabled", true)
      .removeClass("loading")
      .text("SOLD OUT");

  }


  updateQuickViewOptionAvailability();

}



/* ---------------------------------------------------------
   Update impossible variant options
   --------------------------------------------------------- */

function updateQuickViewOptionAvailability() {

  if (
    !ricQuickViewProduct ||
    !ricQuickViewProduct.options
  ) {

    return;

  }


  var selectedOptions =
    getQuickViewSelectedOptions();


  $("#qv-variants .swatch-wrapper")
    .each(function (optionIndex) {

      var position =
        optionIndex + 1;


      $(this)
        .find("input[type='radio']")
        .each(function () {

          var input =
            $(this);


          var candidateValue =
            input.val();


          var candidateOptions =
            selectedOptions.slice();


          candidateOptions[
            optionIndex
          ] = candidateValue;


          var matchingVariant =
            findQuickViewVariant(
              candidateOptions
            );


          var label =
            $("label[for='" + input.attr("id") + "']");


          /*
           * Keep the option selectable if
           * Shopify has a matching variant.
           */

          if (matchingVariant) {

            label
              .removeClass("qv-option-disabled");

          } else {

            label
              .addClass("qv-option-disabled");

          }

        });

    });

}



/* ---------------------------------------------------------
   Quick View select change
   --------------------------------------------------------- */

$(document).on(
  "change",
  "#qv-variants .select__select",
  function () {

    var position =
      $(this).data("qv-option-position");


    /*
     * Synchronize corresponding radio.
     */

    var value =
      $(this).val();


    var wrapper =
      $(this)
        .closest(".dropdown-wrapper")
        .prev(".swatch-wrapper");


    if (wrapper.length) {

      wrapper
        .find("input[type='radio']")
        .prop("checked", false)
        .filter(function () {

          return normalizeQvValue(
            $(this).val()
          ) === normalizeQvValue(
            value
          );

        })
        .prop("checked", true);

    }


    updateQuickViewVariant();

  }
);



/* ---------------------------------------------------------
   Quick View visible option click
   --------------------------------------------------------- */

$(document).on(
  "click",
  "#qv-variants .swatch-wrapper label",
  function (event) {

    event.preventDefault();


    var label =
      $(this);


    var position =
      label.data("option-position");


    var value =
      label
        .prevAll("input[type='radio']")
        .first()
        .val();


    /*
     * More reliable way of finding
     * the corresponding radio.
     */

    var inputId =
      label.attr("for");


    var input =
      $("#" + inputId);


    if (!input.length) {
      return;
    }


    value =
      input.val();


    input.prop(
      "checked",
      true
    );


    $("#select-option" + position)
      .val(value)
      .trigger("change");

  }
);



/* ---------------------------------------------------------
   Quick View thumbnail click
   --------------------------------------------------------- */

$(document).on(
  "click",
  "#qv-thumbnails .thumb-item",
  function () {

    var image =
      $(this)
        .find("img")
        .attr("data-src");


    if (!image) {

      image =
        $(this)
          .find("img")
          .attr("src");

    }


    if (image) {

      $("#qv-product-cover img")
        .attr(
          "src",
          image
        );

    }

  }
);



/* =========================================================
   QUICK VIEW THUMBNAILS
   ========================================================= */

function prepareQvThumbnails(images) {

  var rtlFlag =
    ($('body').hasClass('lang-rtl'))
      ? true
      : false;


  var thumbnailContainer =
    $('#qv-thumbnails');


  var thumbnailSliderWrapper =
    $('<div class="owl-carousel"></div>');


  $(images || []).each(
    function (i, src) {

      thumbnailSliderWrapper.append(

        '<div class="thumb-item item">' +

          '<img ' +
          'data-src="' + src + '" ' +
          'alt="qv-img" ' +
          'class="lazyload" ' +
          'src="' + src + '">' +

        '</div>'

      );

    }
  );


  thumbnailContainer
    .html(
      thumbnailSliderWrapper
    );


  thumbnailSliderWrapper.owlCarousel({

    nav: true,

    navText: [

      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>',

      '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>'

    ],

    dots: false,
    loop: false,
    margin: 15,
    rtl: rtlFlag,
    rewind: true,

    responsive: {

      0: {
        items: 3
      },

      544: {
        items: 4
      },

      768: {
        items: 3
      },

      992: {
        items: 4
      },

      1200: {
        items: 4
      }

    }

  });

}



/* =========================================================
   QUICK VIEW ADD TO CART
   ========================================================= */

$(document).on(
  "click",
  "#qv-add-to-cart",
  function (event) {

    event.preventDefault();


    var button =
      $(this);


    /*
     * Prevent double-click.
     */

    if (
      button.hasClass("loading") ||
      button.hasClass("sold-out") ||
      button.prop("disabled")
    ) {

      return false;

    }


    var variantId =
      $("#qv-variantid").val();


    var qty =
      parseInt(
        $("#qv-quantity-selector input").val(),
        10
      );


    /*
     * Safe quantity.
     */

    if (
      !Number.isFinite(qty) ||
      qty < 1
    ) {

      qty = 1;

    }


    /*
     * Must have a real Shopify variant ID.
     */

    if (
      !variantId ||
      !ricQuickViewCurrentVariant
    ) {

      return false;

    }


    button
      .addClass("loading")
      .prop("disabled", true)
      .text("ADDING...");


    /*
     * Native Shopify AJAX Cart API.
     *
     * This bypasses the broken Quick View
     * addToCartJS dependency.
     */

    $.ajax({

      type: "POST",

      url: "/cart/add.js",

      data: JSON.stringify({

        items: [

          {
            id: Number(variantId),
            quantity: qty
          }

        ]

      }),

      dataType: "json",

      contentType: "application/json"

    })

    .done(function (response) {

      /*
       * Successful add.
       */

      button
        .removeClass("loading")
        .prop("disabled", false)
        .text("ADD TO CART");


      /*
       * Close Quick View.
       */

      $("#ModalClose-quick-view")
        .trigger("click");


      /*
       * Give the modal a moment to close,
       * then refresh/open the cart drawer
       * if the theme provides it.
       */

      setTimeout(function () {

        if (
          typeof openCartDrawer === "function"
        ) {

          openCartDrawer();

        }

      }, 250);


      /*
       * Notify any theme components
       * listening for cart updates.
       */

      $(document).trigger(
        "cart:updated",
        [response]
      );


      $(document).trigger(
        "cart:refresh"
      );

    })

    .fail(function (xhr) {

      console.error(
        "RIC Quick View Add to Cart failed:",
        xhr
      );


      button
        .removeClass("loading")
        .prop("disabled", false)
        .text("ADD TO CART");


      /*
       * Try to provide a useful error.
       */

      var message =
        "Unable to add this item to cart.";


      if (
        xhr.responseJSON &&
        xhr.responseJSON.description
      ) {

        message =
          xhr.responseJSON.description;

      }


      console.error(
        "Shopify Cart Error:",
        message
      );

    });


    return false;

  }
);



/* =========================================================
   QUICK VIEW QUANTITY
   ========================================================= */

$(document).on(
  "click",
  "#qv-quantity-selector button",
  function (event) {

    event.preventDefault();


    var button =
      $(this);


    var input =
      $("#qv-quantity-selector input");


    if (!input.length) {
      return;
    }


    var current =
      parseInt(
        input.val(),
        10
      );


    if (
      !Number.isFinite(current) ||
      current < 1
    ) {

      current = 1;

    }


    /*
     * Detect minus/plus from
     * existing theme markup.
     */

    var text =
      button.text()
        .trim()
        .toLowerCase();


    var aria =
      button.attr("aria-label") || "";


    if (
      text === "-" ||
      aria.toLowerCase().indexOf("minus") !== -1 ||
      aria.toLowerCase().indexOf("decrease") !== -1
    ) {

      current =
        Math.max(
          1,
          current - 1
        );

    } else if (
      text === "+" ||
      aria.toLowerCase().indexOf("plus") !== -1 ||
      aria.toLowerCase().indexOf("increase") !== -1
    ) {

      current++;

    }


    input.val(current);

  }
);



/* ---------------------------------------------------------
   Quantity input validation
   --------------------------------------------------------- */

$(document).on(
  "input change",
  "#qv-quantity-selector input",
  function () {

    var value =
      parseInt(
        $(this).val(),
        10
      );


    if (
      !Number.isFinite(value) ||
      value < 1
    ) {

      $(this).val(1);

    }

  }
);



/* =========================================================
   END RIC QUICK VIEW
   ========================================================= */

/* =========================================================
   RIC CUSTOM EVENT TRACKING
   Quick View + Checkout Maintenance Marketplace
   ========================================================= */

(function () {

  function ricPublish(eventName, payload) {
    if (
      window.Shopify &&
      Shopify.analytics &&
      typeof Shopify.analytics.publish === 'function'
    ) {
      Shopify.analytics.publish(eventName, payload);
      return true;
    }

    return false;
  }


  /*
   * QUICK VIEW OPEN
   *
   * Opening Quick View is a product interaction and therefore
   * counts as ric:product_click.
   */
  document.addEventListener('click', function (event) {

    var quickViewButton =
      event.target.closest &&
      event.target.closest('.quick-view');

    if (quickViewButton) {

      var product =
        window.ricQuickViewProduct || null;

      var handle =
        quickViewButton.getAttribute('data-handle') || '';

      ricPublish('ric:product_click', {

        product_name:
          quickViewButton.getAttribute('data-ric-product-name') ||
          (product && product.title) ||
          handle,

        product_id:
          quickViewButton.getAttribute('data-ric-product-id') ||
          (product && product.id) ||
          '',

        variant_id:
          quickViewButton.getAttribute('data-ric-variant-id') ||
          (
            product &&
            product.variants &&
            product.variants[0] &&
            product.variants[0].id
          ) ||
          '',

        variant_title:
          quickViewButton.getAttribute('data-ric-variant-title') ||
          (
            product &&
            product.variants &&
            product.variants[0] &&
            product.variants[0].title
          ) ||
          '',

        product_url:
          quickViewButton.getAttribute('data-ric-product-url') ||
          (handle ? '/products/' + handle : ''),

        click_location: 'quick-view',

        page_type:
          document.body.classList.contains('template-search')
            ? 'search'
            : 'product-grid',

        source_component: 'product_quickview'

      });

      return;
    }


    /*
     * QUICK VIEW MARKETPLACE BUTTON
     */

    var qvMarketplace =
      event.target.closest &&
      event.target.closest('.qv-marketplace-button');

    if (qvMarketplace) {

      var qvProduct =
        window.ricQuickViewProduct || null;

      var marketplace =
        qvMarketplace.getAttribute('data-marketplace') || '';

      ricPublish('ric:marketplace_click', {

        marketplace: marketplace,

        destination_url:
          qvMarketplace.getAttribute('href') || '',

        page_type: 'quickview',

        source_component: 'product_quickview',

        product_name:
          qvProduct && qvProduct.title
            ? qvProduct.title
            : '',

        product_id:
          qvProduct && qvProduct.id
            ? qvProduct.id
            : '',

        variant_id:
          window.ricQuickViewCurrentVariant &&
          window.ricQuickViewCurrentVariant.id
            ? window.ricQuickViewCurrentVariant.id
            : '',

        variant_title:
          window.ricQuickViewCurrentVariant &&
          window.ricQuickViewCurrentVariant.title
            ? window.ricQuickViewCurrentVariant.title
            : '',

        product_url:
          qvProduct && qvProduct.handle
            ? '/products/' + qvProduct.handle
            : '',

        page_url: window.location.href

      });

      return;
    }


    /*
     * CHECKOUT MAINTENANCE MODAL MARKETPLACES
     */

    var checkoutMarketplace =
      event.target.closest &&
      event.target.closest(
        '[data-ric-checkout-marketplace]'
      );

    if (checkoutMarketplace) {

      var modal =
        checkoutMarketplace.closest(
          '[data-ric-inquiry-modal]'
        );

      ricPublish('ric:marketplace_click', {

        marketplace:
          checkoutMarketplace.getAttribute(
            'data-ric-checkout-marketplace'
          ) || '',

        destination_url:
          checkoutMarketplace.getAttribute(
            'data-ric-destination'
          ) ||
          checkoutMarketplace.getAttribute('href') ||
          '',

        page_type: 'checkout_modal',

        source_component:
          'checkout_maintenance_modal',

        trigger: 'checkout_button',

        checkout_triggered: true,

        country:
          modal &&
          modal.getAttribute('data-country')
            ? modal.getAttribute('data-country')
            : '',

        cart_item_count:
          modal
            ? Number(
                modal.getAttribute(
                  'data-cart-item-count'
                ) || 0
              )
            : 0,

        cart_total:
          modal
            ? Number(
                modal.getAttribute(
                  'data-cart-total'
                ) || 0
              )
            : 0,

        cart_currency:
          modal
            ? modal.getAttribute(
                'data-cart-currency'
              ) || ''
            : '',

        page_url: window.location.href

      });

    }

  }, true);

})();
